import { render, staticRenderFns } from "./ShopNewsDetail.vue?vue&type=template&id=8e12b534"
import script from "./ShopNewsDetail.vue?vue&type=script&lang=js"
export * from "./ShopNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports